import { IconType } from "./icons.types";

export const DeleteIcon = ({ className, color = "#202224" }: IconType) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.6">
        <path
          d="M3.125 5.5V11.75C3.125 13.1307 4.24429 14.25 5.625 14.25H9.375C10.7557 14.25 11.875 13.1307 11.875 11.75V5.5M8.75 7.375V11.125M6.25 7.375L6.25 11.125M10 3.625L9.12108 2.30662C8.88925 1.95888 8.49896 1.75 8.08102 1.75H6.91898C6.50104 1.75 6.11075 1.95888 5.87892 2.30662L5 3.625M10 3.625H5M10 3.625H13.125M5 3.625H1.875"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
